import React, { useEffect, useState } from 'react'
import './ticket-detail.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router'
import { Icon, Tabs } from 'antd-mobile'
import Info from '@/pages/repair/ticket-detail/info/info'
import TicketSteps from '@/pages/repair/ticket-detail/ticket-steps/ticket-steps'
function TicketDetail({ match, history }: any) {
  const [tabs] = useState([{ title: '保修详情' }, { title: '工单动态' }])
  const [curIndex, setCurIndex] = useState(0)
  const id = match.params.id
  useEffect(() => {
    setHeader({
      title: '报修描述',
      nav: <span className="ticket-hide"></span>,
    })
  }, [])
  return (
    <div className="ticket-detail">
      <div className="header">
        <div className="navbar-left">
          <Icon
            type="left"
            onClick={() => {
              if (history.length > 1) {
                history.goBack()
              } else {
                if (window.WebViewBridge) {
                  window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
                } else if (window.webkit) {
                  window.webkit.messageHandlers.navBackMarket.postMessage('')
                }
              }
            }}
          />
        </div>
        <div className="navbar-content">
          <Tabs
            tabs={tabs}
            onChange={(tab, index) => {
              setCurIndex(index)
            }}
            initialPage={0}
            renderTab={tab => <span>{tab.title}</span>}
          ></Tabs>
        </div>
      </div>
      <div className="ticket-content">
        {curIndex === 1 ? <TicketSteps id={id} /> : <Info id={id} />}
      </div>
    </div>
  )
}
export default withRouter(TicketDetail)
